import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Decorative";
import ReelEmbed from "./ReelEmbed";
import { GALLERY_IMAGES } from "../lib/constants";
import { ROUTES } from "../lib/seo";

// Homepage teaser: one reel + a link through to the full set on the pillar.
// DbS-rdhPuen for now (may change after review).
const REEL = {
  url: "https://www.instagram.com/reel/DbS-rdhPuen/",
  poster: GALLERY_IMAGES[5],
  posterSize: [1400, 933],
  alt: "An Antara bhajan jamming evening — Instagram reel",
};

export default function ReelTeaser() {
  return (
    <section className="bg-ivory-2 py-24 md:py-32 px-6" data-testid="reel-teaser-section">
      <div className="max-w-md mx-auto text-center">
        <Reveal>
          <Eyebrow>On Instagram</Eyebrow>
          <h2 className="mt-4 font-display text-4xl md:text-5xl text-ink">A moment from the room</h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-10 mx-auto w-full max-w-[320px]">
            <ReelEmbed url={REEL.url} poster={REEL.poster} posterSize={REEL.posterSize} alt={REEL.alt} />
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <Link
            to={`${ROUTES.pillar.path}#reels`}
            className="mt-10 inline-flex items-center gap-2 font-body text-sm tracking-wide text-amber hover:text-gold transition"
            data-testid="more-from-the-room"
          >
            More from the room <ArrowRight size={15} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
